/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import { Box, Text } from "@towersystems/towersystems-design-system";
import Button from "components/button";
import { resetDashboard, saveDashboard } from "state/dashboard/actions";
import { showSavePrompt } from "state/dashboard/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const SaveLayoutPrompt = ({ layoutId, visible, save, reset }) => {
  const [isSaving, setSaving] = useState(false);

  if (visible === false) {
    return null;
  }

  const resetLayout = () => {
    reset();
  };

  const saveLayout = async () => {
    try {
      setSaving(true);
      await save();
    } catch (e) {}
    setSaving(false);
  };

  return (
    <Box className="save-layout-prompt">
      <Text size="xsmall" weight="medium" className="save-layout-prompt__text">
        Layout Changed
      </Text>
      <Box>
        <Button compact onClick={resetLayout}>
          Reset
        </Button>
      </Box>
      <Box>
        <Button
          className="save-layout-prompt__btn-save"
          compact
          primary
          onClick={saveLayout}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default connect(
  (state) => ({
    visible: showSavePrompt(state),
  }),
  {
    reset: resetDashboard,
    save: saveDashboard,
  }
)(SaveLayoutPrompt);
